import { Routes } from '@angular/router';
import { ConnectorAuthGuard } from '../shared/services/common/connector-auth-guard.service';
import { IdasAuthGuard } from '../shared/services/common/idas-auth-guard.service';
import { AuthGuard } from '../shared/services/common/auth-guard.service';
import { ConnectorOnsetComponent } from './connector-onset/connector-onset.component';
import { ConnectorComponent } from './connector/connector.component';
import { DemoComponent } from './demo/demo.component';
import { HomeComponent } from './home/home.component';
import { IdasOnsetComponent } from './idas-onset/idas-onset.component';
import { OnsetStudyComponent } from './onset-study/onset-study.component';
import { OnsetStudyHomeComponent } from './onset-study-home/onset-study-home.component';
import { GerInfoPageComponent } from './ger-info/ger-info.component';
import { StudyGuidePlacementTestComponent } from './study-guide-placement-test/study-guide-placement-test.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'demo', component: DemoComponent },
  { path: 'connector', component: ConnectorComponent },
  { path: 'connector-onset', component: ConnectorOnsetComponent, canActivate: [ConnectorAuthGuard] },
  { path: 'idas-onset', component: IdasOnsetComponent, canActivate: [IdasAuthGuard] },
  { path: 'onset-with-tan', loadChildren: () => import('./onset-with-tan/onset-with-tan.routes').then(m => m.ONSET_WITH_TAN_ROUTES), canActivate: [AuthGuard] },
  { path: 'onset-study', component: OnsetStudyComponent, canActivate: [AuthGuard] },
  { path: 'onset-study-home', component: OnsetStudyHomeComponent },
  { path: 'ger-info', component: GerInfoPageComponent },
  { path: 'study-guide-placement-test/:onsetBookingId', component: StudyGuidePlacementTestComponent },
  { path: '**', component: HomeComponent },
];
